import React from 'react';
import {Table,Button,Divider,Select,message} from 'antd';
import {createUuid} from '../../../utils/NHCore';
import NHFetch from '../../../utils/NHFetch';
const Option = Select.Option;
const baseUrl = "/fwwgl/zzbd/";

export default class YlhjpzSet extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            ylhjData:[],
            ylhjOptions:[],
            ylhjKeys:[],
            ylhjMap:{},
            currentPage:1
        }
    }
    componentDidMount(){
        this.getYlhjData();
    }
    //根据流程ID获取已绑定的依赖
    getYlhjData = ()=>{
        let initFormData = this.props.initFormData;
        let sign = 'YLHJ_SIGN';
        NHFetch(baseUrl + sign + '/getYlhjData', 'GET').then(res=>{
            let ylhjData = [];
            let ylhjOptions = [];
            let ylhjMap = {};
            if(res && res.data){
                ylhjData = res.data;
                for(let obj of res.data){
                    ylhjOptions.push(<Option key={obj.zzbdhjid} value={obj.zzbdhjid}>{obj.zzbdhjmc}</Option>);
                    ylhjMap[obj.zzbdhjid] = `${obj.zzbdhjmc}`;
                }
            }
            this.setState({ylhjOptions,ylhjData,ylhjMap});
        })
    }
    
    //验证
    validateFields = (func)=>{
        let initFormData = this.props.initFormData;
        let err = false;
        let ylhjData = this.state.ylhjData;
        func(err,ylhjData);
    }
    /**handleHjywxChange = (value,index)=>{
        let ylhjData = this.state.ylhjData;
        let pkid = ylhjData[index].pkid;
        let newData = ylhjData.filter(record => (record.pkid!=pkid && record.hjywxid == value));
        if(newData && newData.length>0){
            message.warning("不能重复设置。");
        }else{
            ylhjData[index].hjywxid = value;
            ylhjData[index].ylhjids = [];
            this.setState({ylhjData});
        }
    }**/
    handleYlywxChange = (value,index)=>{
        let pageIndex = index + (this.state.currentPage - 1) * 10;
        let ylhjData = this.state.ylhjData;
        let {zzbdhjid} = ylhjData[pageIndex];
        let newData = ylhjData.filter(record => (value.includes(record.zzbdhjid) 
        && record.ylhjids.includes(zzbdhjid)));
        if((newData && newData.length>0)||value.includes(zzbdhjid)){
            message.warning("不能设置成死循环。");
        }else{
            ylhjData[pageIndex].ylhjids = value;
            this.setState({ylhjData});
        }
    }
    
    tableOnChange=(pagination)=>{
        this.setState({currentPage : pagination.current});
    }
    render(){
        let {ylhjData,ylhjOptions,ylhjMap} = this.state;

        let columns = [
            {
                title: '序号',
                key: 'pxh',
                dataIndex: 'pxh',
                width: '60px',
                render: (text, record, index) => {
                    return <span>{index+1}</span>
                }
            }, {
                title: '自助报到名称',
                key: 'zzbdhjmc',
                dataIndex: 'zzbdhjmc',
                width: '400px',
            }, {
                title: '配置依赖环节',
                key: 'ylhjids',
                dataIndex: 'ylhjids',
                width: '500px',
                render: (text, record, index) => {
                    let {ylhjids,editable} = record;
                    /**let selectValue = ylhjids.length>0?ylhjids.map(ylhjid=>{
                        return ylhjMap[ylhjid];
                    }).join('，'):'';**/
                    return (                       
                        <Select mode="multiple" value={ylhjids} style={{minWidth:'500px'}}
                            onChange={(value)=>{this.handleYlywxChange(value,index);}}>
                                {ylhjOptions}
                        </Select>                      
                    );
                }
            }
            /**, {
                title: '操作',
                key: 'operation',
                dataIndex: 'operation',
                width: '80px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    return (
                        editable ? <span>
                            <a style={{ margin: 0 }} onClick={() => this.changeRecord(index)}>保存</a>
                            <Divider type={'vertical'} />
                            <a onClick={() => this.removeRecord(record.pkid)}>删除</a>
                        </span> : <span>
                            <a style={{ margin: 0 }} onClick={() => this.changeRecord(index)}>编辑</a>
                        </span>
                    );
                }
            }**/
        ]
        return <div>
            <Table dataSource={ylhjData} columns={columns} onChange={(pagination)=>{this.tableOnChange(pagination)}} rowKey={record=>record.pkid} pagination={true} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./components/fwwgl/zzbd/YlhjpzForm.js